var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 428 428",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m317 278.906-25 25.403a6.297 6.297 0 0 1-2.691 1.843L226.422 327h38.695a8 8 0 0 1 0 16H52.11a8 8 0 0 1 0-16h166.383c-.68 0-1.312-.738-1.875-1.3a7.843 7.843 0 0 1-1.93-8.098l4.82-14.602H52.11a8 8 0 0 1 0-16h172.746l11.282-33.898a6.703 6.703 0 0 1 1.617-2.95L317 170.645V81h-72.09c-4.418 0-7.91-3.129-7.91-7.55V0H0v428h317zM52.11 247h113.007a8 8 0 0 1 0 16H52.11a8 8 0 0 1 0-16zm213.007 136H52.11a8 8 0 0 1 0-16h213.008a8 8 0 0 1 0 16zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 11.809V65h53.555zM234.945 307.64l37.028-12.378-24.649-24.649zM286.766 287.426l101.289-101.512-31.383-31.383-101.512 101.29zM423.59 150.297l-31.305-31.3-24.289 24.233 31.36 31.356zm0 0",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.bdc0c73669bc87aa33fee42edbb81fc0.svg";
export { ForwardRef as ReactComponent };